module.exports = __webpack_public_path__ + "img/banner.95fa7cea.jpg";